import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import MicroFrontendError from '../MicroFrontendError/MicroFrontendError';
import { MicroFrontendErrorType } from '../MicroFrontendError/MicroFrontendErrorType';
export class MicroFrontendErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.logger) {
            this.props.logger.debug(error, errorInfo);
        }
    }
    render() {
        if (this.state.hasError) {
            const { fallbackComponent } = this.props;
            return (fallbackComponent || (_jsx(MicroFrontendError, { type: MicroFrontendErrorType.Exception })));
        }
        return this.props.children;
    }
}
//# sourceMappingURL=MicroFrontendErrorBoundary.js.map